import { render, staticRenderFns } from "./QuantumLead.vue?vue&type=template&id=ec5bf33c&"
import script from "./QuantumLead.vue?vue&type=script&lang=js&"
export * from "./QuantumLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports